var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 6.29688C21.9375 13 11.375 18.6875 11.375 18.6875C11.375 18.6875 0.8125 13 0.8125 6.29688C0.8125 4.84233 1.39032 3.44736 2.41884 2.41884C3.44736 1.39032 4.84233 0.8125 6.29688 0.8125C8.59117 0.8125 10.5564 2.06273 11.375 4.0625C12.1936 2.06273 14.1588 0.8125 16.4531 0.8125C17.9077 0.8125 19.3026 1.39032 20.3312 2.41884C21.3597 3.44736 21.9375 4.84233 21.9375 6.29688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.335 2.45635L11.375 2.5096L11.415 2.45635C12.5495 0.945348 14.3705 0.0500081 16.4531 0.0500002C18.1093 0.0518748 19.6971 0.71063 20.8683 1.88175C22.0394 3.05287 22.6981 4.64072 22.7 6.29693C22.7 9.8282 20.0803 13.0312 17.3904 15.3869C14.703 17.7404 11.9593 19.2363 11.7365 19.3542C11.6255 19.4139 11.5011 19.4454 11.375 19.4454C11.2489 19.4454 11.1248 19.4141 11.0138 19.3544C10.791 19.2365 8.04695 17.7404 5.35964 15.3869C2.6697 13.0312 0.0500133 9.82818 0.0500002 6.2969C0.0518748 4.6407 0.71063 3.05286 1.88175 1.88175C3.05286 0.71063 4.6407 0.0518748 6.2969 0.0500002C8.37954 0.0500078 10.2005 0.945347 11.335 2.45635ZM11.3498 17.7963L11.375 17.811L11.4002 17.7963C12.3278 17.2547 14.7689 15.7497 16.9787 13.6978C19.186 11.6483 21.175 9.04179 21.175 6.29688C21.1734 5.04508 20.6754 3.84494 19.7902 2.95979C18.9051 2.07463 17.705 1.57663 16.4532 1.575C14.4597 1.575 12.7815 2.63446 12.0803 4.34819C12.0229 4.48804 11.9251 4.60766 11.7996 4.69184C11.674 4.77602 11.5262 4.82096 11.375 4.82096C11.2238 4.82096 11.076 4.77602 10.9504 4.69184C10.8249 4.60766 10.7271 4.48804 10.6697 4.34819C9.96856 2.63755 8.29042 1.575 6.29688 1.575C5.04508 1.57663 3.84494 2.07463 2.95979 2.95979C2.07463 3.84494 1.57663 5.04501 1.575 6.29681C1.575 9.04577 3.56344 11.6526 5.77053 13.7012C7.98014 15.7523 10.4212 17.2552 11.3498 17.7963Z",
    fill: "black",
    stroke: "#FFE1E1",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ca4d68209b145f0ee7b8e74162fab32c.svg";
export { ForwardRef as ReactComponent };